import { z } from "zod";

import { extractCpfDigits } from "@/utils/cpf-mask";
import { isValidCPF } from "@/utils/format-cps";

import { NEW_RESPONSIBLE_CPF_MESSAGES } from "./messages";

export const newResponsibleCpfSchema = z
  .string()
  .transform(extractCpfDigits)
  .refine((digits: string) => digits.length === 0 || isValidCPF(digits), {
    message: NEW_RESPONSIBLE_CPF_MESSAGES.INVALID,
  });

export type NewResponsibleCpf = z.infer<typeof newResponsibleCpfSchema>;
